export const BECH32_PUBKEY_ACC_PREFIX = 'injpub';
export const BECH32_PUBKEY_VAL_PREFIX = 'injvaloperpub';
export const BECH32_PUBKEY_CONS_PREFIX = 'injvalconspub';
export const BECH32_ADDR_ACC_PREFIX = 'inj';
export const BECH32_ADDR_VAL_PREFIX = 'injvaloper';
export const BECH32_ADDR_CONS_PREFIX = 'injvalcons';
export const DEFAULT_DERIVATION_PATH = "m/44'/60'/0'/0/0";
